import { ReactElement } from "react"
import styled from "styled-components"

const ButtonElement = styled.button<{ $width: string, $bgcolor?: string, $labelcolor?: string, $bordercolor?: string, $padding?: string }>`
  appearance: none;
  -webkit-appearance: none;
  border: ${props => props.$bordercolor ? `1px solid ${props.$bordercolor}` : 'none'};
  background: none;
  background-color: ${props => props.$bgcolor || props.theme.colors.dark};
  color: ${props => props.$labelcolor || props.theme.colors.white};
  font-weight: 600;
  border-radius: 12px;
  width: ${props => props.$width};
  padding-top: ${props => props.$padding || '14px'};
  padding-bottom: ${props => props.$padding || '14px'};
  cursor: pointer;
  outline: none;

  &:active {
    transform: scale(.99);
  }
`

export default function Button({ label, width, onclick, bgcolor, labelcolor, bordercolor, padding }: { label: string | ReactElement, width: string, onclick: () => void, bgcolor?: string, labelcolor?: string, bordercolor?: string, padding?: string }) {
  return (
    <ButtonElement onClick={onclick} value={label.toString()} $width={width} $bgcolor={bgcolor} $labelcolor={labelcolor} $bordercolor={bordercolor} $padding={padding}>{label}</ButtonElement>
  )
}